module.exports = __webpack_public_path__ + "static/media/Saly-1.820d72bd.png";